import useField from './useField';
function useNestedApps(fieldName = 'features', entryFeatures) {
    let features = useField(fieldName);
    let content = useField('content');
    features = entryFeatures ?? features ?? content?.fields?.features;
    if (!features) {
        // Don't proceed if any of the critical information is missing
        return [];
    }
    // It's easier to expect that we work with an array, even if it's a single reference
    if (!Array.isArray(features)) {
        features = [features];
    }
    return features.map((feature) => ({
        name: feature.sys.contentType?.sys?.id,
        // Get Content ID and also pass all fields.
        // It's important that we pass the version (from the fields), too
        meta: { contentId: feature.sys.id, ...feature.fields },
        // original CMS Data
        entry: feature,
    }));
}
export default useNestedApps;
